"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.EmbeddableSandbox = void 0;
var React = __importStar(require("react"));
var react_1 = require("@apollo/sandbox/react");
var react_2 = require("@chakra-ui/react");
var outdent_1 = require("outdent");
var EmbeddableSandbox = function (_a) {
    var _b = _a.initialEndpoint, initialEndpoint = _b === void 0 ? "http://localhost:4000" : _b, _c = _a.document, document = _c === void 0 ? (0, outdent_1.outdent)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query MyQuery {\n    }\n  "], ["\n    query MyQuery {\n    }\n  "]))) : _c, _d = _a.height, height = _d === void 0 ? 450 : _d;
    var colorMode = (0, react_2.useColorMode)().colorMode;
    return (React.createElement(react_2.Box, { h: height, rounded: "md", sx: {
            ".embed": {
                boxSize: "full"
            }
        } },
        React.createElement(react_1.ApolloSandbox
        // give the component a key or else multiple explorers get rendered when
        // the color mode changes
        , { 
            // give the component a key or else multiple explorers get rendered when
            // the color mode changes
            key: colorMode, className: "embed", initialEndpoint: initialEndpoint, initialState: {
                document: document
            } })));
};
exports.EmbeddableSandbox = EmbeddableSandbox;
var templateObject_1;
